












































































































































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { FormFieldValidation, ObjectHelper, FormSelectHelper } from '@/mixins';
import { ListService } from '@/services/ListService';
import { Dictionary, ListModel, ListDataResultType, FilteredListModel, ListHeaderModel, KeyboardKeyCode } from '@/types';
import FieldActionButton from '@/components/shared/FieldActionButton.vue';
import FieldTooltip from '@/components/shared/FieldTooltip.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ValidationModel } from '@/types/models/validation';
import { ModalHelpers, confirmationHelper } from '@/mixins';
import Toast from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  name: 'MStoreFormLookup',
  mixins: [FormFieldValidation, ObjectHelper, FormSelectHelper, ModalHelpers, confirmationHelper],
  props: {
    data: {
      required: true
    },
    actionButtonState: {
      type: Object,
      required: false
    },
    fieldId: {
      type: String,
      required: true
    },
    fieldLabel: {
      type: String,
      required: true
    },
    isReadonly: {
      type: Boolean,
      required: true
    },
    formId: {
      type: String,
      required: true
    },
    actionButtonComponentName: {
      type: String,
      required: true
    },
    listId: {
      type: Number,
      required: true
    },
    hasInitialList: {
      type: Boolean,
      required: true
    },
    filterDisabled: {
      type: Boolean,
      default: false
    },
    isActionButtonDisabled: {
      type: Boolean,
      default: false
    },
    validation: {
      type: Object as () => ValidationModel,
      required: true
    },
    keyFilterValues: {
      type: Object as () => Dictionary<any>,
      default: () => ({} as Dictionary<any>)
    },
    allowTypedValue: {
      type: Boolean,
      default: false
    },
    allowClearValue: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: ''
    },
    showPlaceholder: {
      type: Boolean,
      default: true
    },
    showAddItem: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isLoading: false,
      filter: this.data,
      lastSelectedValue: this.data,
      lastFilterValue: null,
      listModel: {} as ListModel,
      formLookupHasFocus: false,
      listToAddHeaders: [
        {
          id: '',
          listKey: '',
          fieldName: '',
          value: '',
          isRequired: false
        }
      ],
      existingList: [],
      hasListItemUnsavedChanges: false,
      canAddItemToList: false,
      areManyRecordsOnList: false,
      isAddListItemFormValid: false,
      isAddListItemFormSubmitted: false
    };
  },
  computed: {
    ...mapGetters('listStore', {
      listById: 'listById',
      listStoreLoading: 'isLoading'
    }),
    listDataEmpty(this: any): boolean {
      return !this.listData || this.listData.length === 0;
    },
    inputValue: {
      get(this: any) {
        return this.data;
      },
      set(this: any, value: string) {
        const flags = this.$refs.ValidationProvider.flags;
        this.$refs.ValidationProvider.setFlags({ ...flags, dirty: true });
        this.$emit('update:data', value);
      }
    },
    listResultMessage(): string {
      return this.listModel && (this.listModel.resultType === ListDataResultType.NoRecords || this.listModel.resultType === ListDataResultType.ManyRecords)
        ? this.listModel.listDataResultTypeMessage
        : 'Start typing to filter out list items.';
    },
    isLoadingbyId(this: any): boolean {
      return this.listById(this.listId) === undefined;
    },
    primaryKey(this: any) {
      if (this.listModel) {
        return this.listModel.key;
      }
    },
    sizeAdjustedLabel(this: any) {
      return this.size === 'sm' ? '' : this.fieldLabel;
    },
    sizeAdjustedPlaceHolder(this: any): string {
      return !this.showPlaceholder ? '' : this.size === 'sm' ? this.fieldLabel : '';
    }
  },
  methods: {
    ...mapActions('listStore', ['loadList', 'updateList']),
    async getList(this: any, searchText: string) {
      this.clearListModel();
      if (this.isFilterDisabledOrReadOnly) {
        this.isLoading = this.isLoadingbyId;
        await this.loadList(this.listId, this.keyFilterValues);
        this.listModel = this.listById(this.listId);
      } else {
        this.isLoading = true;
        try {
          this.listModel = await ListService.getListAsync(this.listId, searchText, false, this.keyFilterValues);
        } catch (error) {
          this.$log(error);
        } finally {
          this.isLoading = false;
          if (this.formLookupHasFocus && !this.tableOpen) {
            this.onfilterFocus();
          }
          if (this.tableOpen) {
            this.initPopper();
          }
        }
      }
      this.setAreManyRecordsOnList(this.listModel);
      this.lastFilterValue = searchText;
    },
    async setAreManyRecordsOnList(this: any, listItems: ListModel) {
      if (listItems != null) {
        this.areManyRecordsOnList = listItems.resultType === ListDataResultType.ManyRecords || listItems.headers === null;
      }
    },
    async loadListModel(this: any) {
      this.isLoading = true;
      if (this.filter && !this.filterDisabled) {
        await this.getList(this.filter);
      } else {
        await this.getList('');
      }
    },
    async onFilterButtonClicked(this: any) {
      this.formLookupHasFocus = true;
      if (this.tableOpen) {
        this.closeListAndRetainlastSelectedValue();
      } else {
        this.canAddItemToList = this.showAddItem && (await ListService.getCanAddItemToListAsync(this.listId));
        this.allowClearValue && this.inputValue ? this.clearInputValue() : await this.openTable();
        this.setFocusOnNextTick(this.$refs.mstoreSelectTableButton);
      }
    },
    async openTable(this: any) {
      await this.loadListModel();
      if (!this.formLookupHasFocus) {
        return;
      }
      this.tableOpen = this.listModel != null;
      this.initPopper();
    },
    onInputBoxBlur(this: any) {
      this.formLookupHasFocus = false;
    },
    clearInputValue(this: any) {
      this.inputValue = '';
      this.filter = '';
      this.lastSelectedValue = '';
      this.validate();
    },
    clearListModel() {
      this.listModel = {} as ListModel;
    },
    filterList(filterValue: any, event: any) {
      this.getList(filterValue);
    },
    onEnter(this: any) {
      if (this.totalRows() === 1) {
        this.onRowClicked(this.filteredItems?.[0] || this.listModel.list[0]);
      }
    },
    onAddRowToList(this: any) {
      if (this.canAddItemToList) {
        this.onAddRowToListHandler();
      }
    },
    async onfilterFocus(this: any) {
      this.formLookupHasFocus = true;
      this.canAddItemToList = this.showAddItem && (await ListService.getCanAddItemToListAsync(this.listId));
      if (!this.isReadonly && !this.isLoading && !this.tableOpen) {
        await this.openTable();
      }
    },
    async onAddRowToListHandler(this: any) {
      if (!this.canAddItemToList && this.areManyRecordsOnList) {
        return;
      }
      const sourceListItems = await ListService.getListAsync(this.listId, '', true, this.keyFilterValues);
      if (sourceListItems.headers) {
        this.existingList = sourceListItems.list;
        const requiredField = sourceListItems.key;
        this.listToAddHeaders = sourceListItems.headers.map((header: any) => ({
          id: header.id,
          listKey: header.data,
          fieldName: header.title,
          value: '',
          isRequired: header.data === requiredField ? true : false
        }));
        this.$bvModal.show('addRowToListHandlerModal-' + this.fieldId);
      } else {
        Toast.showError('An error occured. Please try again later');
      }
    },
    setListItemFieldValue(this: any, value: string, index: number) {
      const updatedFieldValue = value || '';
      Vue.set(this.listToAddHeaders[index], 'value', updatedFieldValue);
      this.hasListItemUnsavedChanges = true;
    },
    async onAddListItem(this: any, fieldId: any) {
      this.isAddListItemFormValid = true;
      this.isAddListItemFormSubmitted = true;
      try {
        const isValid = this.listToAddHeaders.every((x: any) => {
          return this.validateFieldValues(x.listKey, x.value, x.isRequired);
        });
        if (!isValid) {
          return;
        }
        const listItems = this.listToAddHeaders.map((listItem: any) => {
          return {
            data: listItem.listKey,
            value: listItem.value.trim()
          };
        });
        await ListService.postListAsync(this.listId, listItems);
        this.updateList(this.listId);
        this.resetAndCloseAddListItemModal(fieldId);
        Toast.showSuccess('List Item has been created successfully!');
      } catch (error) {
        this.$log(error);
      } finally {
        this.isAddListItemFormSubmitted = false;
      }
    },
    async onCancelListItemModal(this: any, fieldId: any) {
      if (!(await this.hasUnsavedChangesToKeepAsync(this.$bvModal, this.hasListItemUnsavedChanges))) {
        this.resetAndCloseAddListItemModal(fieldId);
      }
    },
    resetAndCloseAddListItemModal(this: any, fieldId: any) {
      this.listToAddHeaders = [
        {
          id: '',
          listKey: '',
          fieldName: '',
          value: '',
          isRequired: false
        }
      ];
      this.existingList = [];
      this.hasListItemUnsavedChanges = false;
      this.isAddListItemFormValid = false;
      this.$bvModal.hide('addRowToListHandlerModal-' + fieldId);
    },
    async onRowClicked(this: any, item: any) {
      this.inputValue = item[this.primaryKey];
      this.$emit('row-selected', item);
      this.closeTable();
      if (this.filter !== this.data) {
        this.filter = this.data;
      }
      this.setFocusOnNextTick(this.$refs.mstoreSelectTableButton);
      await Vue.nextTick();
      this.validate();
    },
    validateFieldValues(this: any, listKey: string, value: string, isRequired: boolean): boolean {
      if (value.length > 100) {
        return false;
      }
      if (!isRequired) {
        return true;
      }
      const isUnique = !value || this.existingList.every((listItem: any) => listItem.hasOwnProperty(listKey) && listItem[listKey].trim().toLowerCase() !== value.trim().toLowerCase());
      const isRequiredValid = !(this.isAddListItemFormValid && !Boolean(value.trim()));
      return isUnique && isRequiredValid;
    },
    async initialise(this: any) {
      if (this.filterDisabled || (this.hasInitialList && !this.isReadonly)) {
        await this.getList('');
        this.tableOpen = this.listModel != null && this.formLookupHasFocus;
      }
    }
  },
  watch: {
    isLoadingbyId(value: boolean) {
      this.isLoading = value;
    },
    data(value) {
      this.lastSelectedValue = value;
      this.filter = value;
    },
    tableOpen(value: boolean) {
      if (value === false) {
        this.clearListModel();
      }
    }
  },
  mounted() {
    this.initialise();
  },
  components: {
    FieldActionButton,
    FieldTooltip,
    LoadingSpinner
  }
});
